import { render, staticRenderFns } from "./swap.vue?vue&type=template&id=dc0a6fea&scoped=true&"
import script from "./swap.vue?vue&type=script&lang=js&"
export * from "./swap.vue?vue&type=script&lang=js&"
import style0 from "./swap.vue?vue&type=style&index=0&id=dc0a6fea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0a6fea",
  null
  
)

export default component.exports